import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a35 35 0 0 1-.337 5.316H.325a35 35 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a31 31 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79m31.357-10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M16.004 11.333q.105 0 .21.005a.333.333 0 0 1-.03.666 4 4 0 0 0-.62.02.333.333 0 1 1-.071-.663q.251-.028.511-.028m1.916.412a4.6 4.6 0 0 0-.675-.244.333.333 0 1 0-.178.643q.298.082.579.209a.333.333 0 0 0 .274-.607m.957.58q.282.222.529.485a.333.333 0 0 1-.486.455 4 4 0 0 0-.455-.415.333.333 0 1 1 .412-.525m1.485 2.013a4.6 4.6 0 0 0-.307-.65.333.333 0 1 0-.579.331q.153.268.263.556a.333.333 0 1 0 .623-.237m.305 1.716-.001.053a.333.333 0 1 1-.667-.015v-.045l.001-.045q0-.267-.034-.527a.333.333 0 0 1 .661-.086q.04.302.04.613zm-.368 1.766q.14-.33.228-.681a.333.333 0 0 0-.647-.163q-.075.3-.195.584a.333.333 0 0 0 .614.26m-.564.978a5 5 0 0 1-.473.54.333.333 0 1 1-.466-.477 4 4 0 0 0 .406-.463.333.333 0 1 1 .533.4m-1.973 1.525q.334-.137.642-.322a.333.333 0 0 0-.344-.571q-.265.159-.55.275a.333.333 0 0 0 .252.618M16 20.667A.333.333 0 0 1 16 20q-.14 0-.28-.01a.333.333 0 1 0-.045.666q.162.01.325.01M16 20q.312 0 .614-.047a.333.333 0 0 1 .102.66 5 5 0 0 1-.716.054.333.333 0 0 0 0-.667m-1.562-8.399q-.34.12-.656.292a.333.333 0 1 0 .317.587q.27-.147.562-.25a.333.333 0 0 0-.223-.629m-2.08 1.48a5 5 0 0 1 .491-.523.333.333 0 1 1 .45.491q-.227.21-.42.45a.333.333 0 1 1-.52-.418m-.566.9q-.156.324-.26.67a.333.333 0 0 0 .638.192q.09-.295.223-.573a.333.333 0 1 0-.601-.289M11.334 16q0-.143.008-.287a.333.333 0 1 1 .666.04 4 4 0 0 0 .007.593.333.333 0 0 1-.664.057 5 5 0 0 1-.018-.403m.233 1.462q.113.343.277.663a.333.333 0 1 0 .594-.304 4 4 0 0 1-.238-.568.333.333 0 1 0-.633.21m1.428 2.108a5 5 0 0 1-.512-.503.333.333 0 0 1 .502-.438q.203.233.44.431a.333.333 0 1 1-.43.51m.889.59q.32.163.663.276a.333.333 0 0 0 .207-.634 4 4 0 0 1-.568-.236.333.333 0 0 0-.303.594",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#C2E7FF", fillRule: "evenodd", d: "M16 13.333 18.667 18h-5.334z", clipRule: "evenodd" })
);
var SvgFlagNic = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagNic_default = SvgFlagNic;

export { FlagNic_default as default };
